import { render } from "./adminIndex.vue?vue&type=template&id=e2cabae2&scoped=true"
import script from "./adminIndex.vue?vue&type=script&lang=js"
export * from "./adminIndex.vue?vue&type=script&lang=js"

import "./adminIndex.vue?vue&type=style&index=0&id=e2cabae2&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2cabae2"]])

export default __exports__